export const selectionColWidth = 50;
export const minColWidth = 50;
